(function () {
    "use strict";

    angular.module("app").controller("CisRequestController", CisRequestController);

    CisRequestController.$inject = ["$scope", "controllerDecorator", "cisRequest", "physicalInstallation"];
    function CisRequestController($scope, controllerDecorator, cisRequest, physicalInstallation) {

        const context = { RequestId: null, };
        const vm = this;
        controllerDecorator.Decorate(vm, ["comments", "dialog"]);

        vm.request = null;
        vm.AllowedLevels = $scope.codeFVMCISLevels;
        vm.States = [{ Key: '10' }, { Key: '40' }, { Key: '51' }, { Key: '60' }, { Key: '130' }, { Key: '140' }, { Key: '160' }, { Key: '170' }];

        initialize();
        function initialize() {
            const parsed = vm.ParsePrettyUrl();
            context.RequestId = parsed.id;

            if (!!context.RequestId)
                load();
        }

        function load() {
            cisRequest.Get(
                context.RequestId,
                r => {
                    vm.request = r.data;
                    vm.Comments.Initialize({ RequestId: context.RequestId, DossierId: null, OrganisationId: vm.request.Organisation.PublicId, ICD: vm.request.ScreeningBy });

                    physicalInstallation.GetSecuredZonesForOrganisation(
                        vm.request.Organisation.PublicId,
                        r => {
                            vm.PhysicalInstallations = r.data.filter(i => vm.request.InstallationIds.includes(i.PublicId));
                            vm.PhysicalInstallations.forEach(i => i.IsSelected = true);
                        },
                        vm.ShowError
                    );
                },
                vm.ShowError,
                () => vm.SetLoadingState(false)
            );
        }
    }
})();
